import React from "react";
import { useNavigate } from "react-router-dom";

const SigningSuccessPage: React.FC = () => {
  const navigate = useNavigate()

  React.useEffect(() => {
    // Notify parent window/iframe that signing is complete
    if (window.parent && window.parent !== window) {
      window.parent.postMessage('signing_complete', '*')
    }
  }, [])

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-gray-50 to-green-100 p-6">
      <div className="bg-white rounded-2xl shadow-xl border border-green-200 p-10 max-w-md w-full text-center animate-fadeIn">

        {/* Checkmark */}
        <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-green-600 flex items-center justify-center shadow-lg">
          <span className="text-white text-4xl font-bold">✓</span>
        </div>

        {/* Title */}
        <h2 className="text-2xl font-semibold text-green-700 mb-2">
          Contract Signed Successfully
        </h2>

        {/* Subtitle */}
        <p className="text-gray-600 text-sm mb-6">
          Thank you for signing the contract.
        </p>

        {/* Footer Note */}
        <p className="text-gray-500 text-xs">
          You may now close this dialog or <a className="text-green-700 cursor-pointer" onClick={(e) => {navigate('/contracts')}}>click here to see your contract's. </a>
        </p>
      </div>
    </div>
  );
};

export default SigningSuccessPage;
